import { render, staticRenderFns } from "./EventReview.vue?vue&type=template&id=93e6f692&scoped=true"
import script from "./EventReview.vue?vue&type=script&lang=ts"
export * from "./EventReview.vue?vue&type=script&lang=ts"
import style0 from "./EventReview.vue?vue&type=style&index=0&id=93e6f692&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e6f692",
  null
  
)

export default component.exports